// extracted by mini-css-extract-plugin
export default {"Item":"AssigneePickerBase-module__Item__sPVJjUT"};